import { FC } from 'react';

import { handleBannerTextGenerationChange } from 'utils/banner/utils';

import { MagritteBannerText } from 'components/common/MagritteBannerText/MagritteBannerText';

import { selectBannerDefaultText, selectBannerTextWasGenerated } from 'store/models/bannerTextGeneration';
import {
    QuickCampaignFieldName,
    selectQuickCampaignFormDataField,
    selectQuickCampaignFormErrors,
    setQuickCampaignFieldByName,
} from 'store/models/createQuickCampaign';
import { useDispatch, useSelector } from 'store/utils';

export const BannerText: FC = () => {
    const text = useSelector(selectQuickCampaignFormDataField[QuickCampaignFieldName.Text]);
    const error = useSelector(selectQuickCampaignFormErrors[QuickCampaignFieldName.Text]);
    const vacancyId = useSelector(selectQuickCampaignFormDataField[QuickCampaignFieldName.VacancyId]);
    const bannerTextWasGenerated = useSelector(selectBannerTextWasGenerated);
    const defaultText = useSelector(selectBannerDefaultText);

    const dispatch = useDispatch();

    const onChangeText = (text: string) => {
        handleBannerTextGenerationChange(dispatch, text, defaultText, bannerTextWasGenerated);
        dispatch(setQuickCampaignFieldByName({ fieldName: QuickCampaignFieldName.Text, value: text }));
    };

    const setBannerText = (text: string) =>
        dispatch(setQuickCampaignFieldByName({ fieldName: QuickCampaignFieldName.Text, value: text }));

    return (
        <MagritteBannerText
            value={text}
            onChange={onChangeText}
            setBannerText={setBannerText}
            vacancyId={vacancyId}
            error={error}
            dataQa="ad-quick-create-text"
        />
    );
};
